import { requestGet } from '@/utils/request';
import { TApi } from '@/types/interface';

export interface TUserOptionDTO {
  nameEn: string;
  nameZh: string;
  pernr?: string;
  wxName?: string;
}

export interface TUserPermission {
  /**
   * 是否超管
   */
  superAdmin: boolean;
  /**
   * 是否可以创建打卡营
   */
  createCamp: boolean;
  /**
   * 是否可以管理所有打卡营
   */
  manageCamp: boolean;
  /**
   * 是否可以管理题库
   */
  manageQuestionBank: boolean;
  /**
   * 是否可以管理某些打卡营
   */
  manageSomeCamp: boolean;
}

export function listUser(): Promise<TUserOptionDTO[]> {
  return requestGet(`/v2/camp/api/user/list`, {});
}

/**
 * 获取用户权限
 */
export const getPermission = async (): Promise<TApi<TUserPermission>> => {
  return requestGet(`/v2/camp/api/user/permission`, {});
};
